import DateFnsUtils from '@date-io/date-fns';

import PropTypes from 'prop-types';
import { dropLast, path } from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Fab from '@material-ui/core/Fab';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';

import { withStyles } from '@material-ui/styles';

import GetApp from '@material-ui/icons/GetApp';

import LeftBarHeader from './header';
import { showSnackbarMessage } from '../../modules/actions/layout';


class RideExportBar extends Component {
  static propTypes = {
    // own props
    classes: PropTypes.shape({}),
    handleToggleLeftBar: PropTypes.func.isRequired,

    // state props
    apiAuthorization: PropTypes.string.isRequired,
    apiHost: PropTypes.string.isRequired,

    // dispatch props
    showSnackbarMessage: PropTypes.func.isRequired,
  };

  state = {
    dateBegin: new Date(),
    dateBeginError: undefined,
    dateEnd: new Date(),
    dateEndError: undefined,
  };

  onClickDownload(event) {
    const { dateBegin, dateEnd } = this.state;
    let errors = false;

    if (!dateBegin) {
      this.setState({ dateBeginError: 'Dit veld is verplicht.' });
      errors = true;
    }

    if (!dateEnd) {
      this.setState({ dateEndError: 'Dit veld is verplicht.' });
      errors = true;
    }

    if (dateBegin && dateEnd) {
      if (dateEnd < dateBegin) {
        this.setState({
          dateBeginError: 'De begindatum moet voor de einddatum zijn.',
          dateEndError: 'De einddatum moet voor de begindatum zijn.',
        });
        errors = true;
      }
    }

    const padZeros = (value, count) => {
      let valueString = '' + value;
      let padString = '';
      const pads = count - valueString.length;

      for (let i = 0; i < pads; i++) {
        padString += '0';
      }

      return padString + valueString;
    };

    if (!errors) {
      this.setState({ dateBeginError: undefined, dateEndError: undefined });

      const y1 = dateBegin.getFullYear();
      const y2 = dateEnd.getFullYear();
      const m1 = padZeros(dateBegin.getMonth() + 1, 2);
      const m2 = padZeros(dateEnd.getMonth() + 1, 2);
      const d1 = padZeros(dateBegin.getDate(), 2);
      const d2 = padZeros(dateEnd.getDate(), 2);

      const url = `export/rides/${y1}-${m1}-${d1}/${y2}-${m2}-${d2}`;
      const name = `export-rides-${y1}_${m1}_${d1}-${y2}_${m2}_${d2}.xlsx`;

      this.onFetchFile(url, name);
    }

    event.stopPropagation();
    event.preventDefault();
  }

  async onFetchFile(fileURL, fileName) {
    const { apiAuthorization, apiHost, showSnackbarMessage } = this.props;

    const url = `${apiHost}/${fileURL}`;
    const options = {
      cache: 'default',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        Authorization: apiAuthorization,
      },
      method: 'GET',
      mode: 'cors',
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        switch (response.status) {
          case 403: throw new Error('U heeft geen toestemming om deze export op te vragen.');
          case 406: throw new Error('De server ondersteunt geen Excel-bestanden.');
          case 500: throw new Error('Er is iets fout gegaan bij het genereren van het Excel-bestand.');
          default: throw new Error(response.statusText);
        }
      }

      const blob = await response.blob();
      const objectURL = window.URL.createObjectURL(blob);

      const anchor = window.document.getElementById('download-xlsx');

      anchor.href = objectURL;
      anchor.download = fileName;
      anchor.click();

      window.URL.revokeObjectURL(objectURL);
    } catch (error) {
      showSnackbarMessage(error.message);
    }
  }

  render() {
    const { classes, handleToggleLeftBar } = this.props;
    const { dateBegin, dateBeginError, dateEnd, dateEndError } = this.state;

    return (
      <div>
        <LeftBarHeader
          handleToggleLeftBar={handleToggleLeftBar}
          title="Rittenexport"
          icon={<GetApp />}
        />

        <List>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ListItem>
              <DatePicker
                animateYearScrolling
                disableFuture
                label="Begindatum"
                value={dateBegin}
                onChange={date => this.setState({ dateBegin: date, dateBeginError: undefined })}
                helperText={dateBeginError}
              />
            </ListItem>

            <ListItem>
              <DatePicker
                animateYearScrolling
                disableFuture
                label="Einddatum"
                value={dateEnd}
                onChange={date => this.setState({ dateEnd: date, dateBeginError: undefined })}
                helperText={dateEndError}
              />
            </ListItem>
          </MuiPickersUtilsProvider>

          <ListItem className={classes.downloadButtonListItem}>
            <div onClick={event => this.onClickDownload(event)}>
              <Fab color="primary" aria-label="edit" size="small">
                <GetApp />
              </Fab>
            </div>

            <a id="download-xlsx" style={{ display: 'none' }}>
              Download Excel export.
            </a>
          </ListItem>
        </List>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  apiAuthorization: path(['api', 'endpoint', 'axiosConfig', 'headers', 'Authorization'], state),
  apiHost: dropLast(4, path(['api', 'endpoint', 'axiosConfig', 'baseURL'], state) || ''),
});

export default connect(mapStateToProps, { showSnackbarMessage })(withStyles({
  downloadButtonListItem: {
    justifyContent: 'center',
    marginTop: 40,
  }
})(RideExportBar));
